import {FC} from "react";
import {News} from "../components/News";

export const NewsPage: FC = () => {
    return <News/>
};